<template>
    <div>
        <ul class="sbs sbs--basic row mb-4" style="padding-left: 0px !important;">
            <li :class=" showFormInformations ? 'finished col-lg-4' : 'col-lg-4' " style="cursor: pointer;">
                <div class="step">
                    <span class="title">Étape 2</span>
                    <span class="description" :style=" showFormInformations ?  'color: #000' : 'color: #8a94a1' ">Vos coordonnées</span>
                </div>
            </li>
            <li :class=" showFormIdentification ? 'finished col-lg-4' : 'col-lg-4' " style="cursor: pointer;">
                <div class="step">
                    <span class="title">Étape 3</span>
                    <span class="description" :style=" showFormIdentification ?  'color: #000' : 'color: #8a94a1' ">Votre identité</span>
                </div>
            </li>
            <li :class=" showFormPaiement || showContent ? 'finished col-lg-4' : 'col-lg-4' " style="cursor: pointer;">
                <div class="step">
                    <span class="title">Étape 4</span>
                    <span class="description" :style=" showFormPaiement || showContent ?  'color: #000' : 'color: #8a94a1' ">Votre paiement</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

    export default {
        components:{
        },
        data() {
            return {
            }
        },
        props: [ 'showFormInformations', 'showFormPaiement', 'showFormIdentification', 'showContent' ],
        mounted(){
        },
        methods: {
            // Reload la page
            reload(){
                location.reload();
            },

            validerLeChoixDesCartes()
            {
                this.validerCartes();
            },

            choisirCarte2(carte)
            {
                this.choisirCarte(carte) ;
            },

            voirDetails2(carte)
            {
                this.voirDetails(carte);
            }
        },
    }
</script>

<style scoped>

    table { width:100%; }
    .intitule { font-weight:normal; color:#333;}

    .pos-relative{
        position: relative;
    }

    .pos-relative .line {
        position: relative;
        padding-top: 20px;
    }

    .pos-relative .line:after {
        content: "";
        position: relative;
        left: 40%;
        width: 20%;
        height: 2px;
        background: #faaa13;
        top: -115px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
    }

    .pos-relative2{
        position: relative;
    }

    .pos-relative2 .line2 {
        position: relative;
        padding-top: 50px;
    }

    .pos-relative2 .line2:after {
        content: "";
        position: absolute;
        left: 40%;
        width: 20%;
        height: 4px;
        background: #dfe2e5;
        top: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        /*border-radius: 20px;*/
    }

    .floating-container {
        position: fixed;
        width: auto;
        /* height: 100px; */
        bottom: 40px;
        right: 0;
        margin: 30px 25px;
        z-index: 20;
    }

    .custom-shadow{
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px !important;
    }

    .content {
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: auto;
        overflow: hidden;
    }

    .custom-rounded {
        border-radius: 32px;
    }

    .shadow{
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;
        border-radius: 20px;
    }

    .menu-cabine {
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
    }

    .menu-cabine:hover, .menu-cabine:focus{
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
        /* border-radius: 5px; */
        /* box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px; */
    }

    /*.content .content-overlay {*/
    /*    background: rgba(0,0,0,0.7);*/
    /*    position: absolute;*/
    /*    height: 100%;*/
    /*    width: 100%;*/
    /*    left: 0;*/
    /*    top: 0;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*    opacity: 0;*/
    /*    -webkit-transition: all 0.5s ease-in-out 0s;*/
    /*    -moz-transition: all 0.5s ease-in-out 0s;*/
    /*    transition: all 0.5s ease-in-out 0s;*/
    /*    border-radius: 14px;*/
    /*}*/

    /*.content:hover .content-overlay{*/
    /*    opacity: 1;*/
    /*}*/



    .content-overlay:hover{
        transition: all 0.3s;
        border-color: #faaa13;
        border-style: solid;
        border-width: 2px;
        /*padding: 8px;*/
        border-radius: 25px;
        /*box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;*/
    }

    .content-image{
        width: 100%;
    }

    .content:hover .content-details{
        top: 50%;
        left: 50%;
        opacity: 1;
    }

    .content-details {
        position: absolute;
        text-align: center;
        padding-left: 1em;
        padding-right: 1em;
        width: 100%;
        top: 50%;
        left: 50%;
        opacity: 0;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -webkit-transition: all 0.3s ease-in-out 0s;
        -moz-transition: all 0.3s ease-in-out 0s;
        transition: all 0.3s ease-in-out 0s;
    }

    .fadeIn-top{
        top: 20%;
    }

    .content-details h3{
        color: #fff;
        font-weight: 500;
        letter-spacing: 0.15em;
        margin-bottom: 0.5em;
        text-transform: uppercase;
    }

    .content-details p{
        color: #fff;
        font-size: 0.8em;
    }

    .show-selected-mode{
        position: absolute;
        /*right: 3px;*/
        /*top: -6px;*/
        right: 17px;
        top: 18px;
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .show-selected-mode2{
        position: absolute;
        right: 3px;
        top: -9px;
        /*right: 20px;*/
        /*top: 8px;*/
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .btn-disabled-custom {
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        color: #1b1e21;
        cursor: not-allowed;
    }

    .mode-rechargement {
        display: flex;
        flex-direction: column;
        cursor: pointer;
    }

    @media (max-width: 767px) {
        .content {
            width: 80%;
        }
        .show-selected-mode{
            right: 44px;
        }
    }

    .searchIcon {
        margin-left: -35px;
        cursor: pointer;
        /* color: #261b64; */
        color: #343a40;
        cursor: pointer;
        font-size: 25px;
        z-index: 50;
    }

</style>